import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useBusinessSettingsStore } from "../admin/store/businessSettingsStore";
import { MessageCircle } from "lucide-react";

function WhatsAppFloatingButton() {
  const { settings } = useBusinessSettingsStore();
  const location = useLocation();

  // Only show on public pages (not admin)
  if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/ktec-gate')) return null;

  if (!settings.whatsappNumber) return null;

  const number = settings.whatsappNumber.replace(/[^0-9]/g, '');
  const message = encodeURIComponent(`Hi ${settings.businessName}! I'd like to make an inquiry.`);
  const url = `https://wa.me/${number}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#1ebe5d] rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 active:scale-95"
      style={{ boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)' }}
    >
      <MessageCircle className="w-7 h-7 text-white" />
    </a>
  );
}

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
}
